import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "axios"; // fallback
import { getAxiosByRole } from "../../utils/getAxiosByRole.js";
import { url } from "../../baseUrl.js";

export const submitFeedback = createAsyncThunk(
  "feedback/submit",
  async ({ formData, role }, { rejectWithValue }) => {
    try {
      const axiosClient = role ? getAxiosByRole(role) : axios;

      const res = await axiosClient.post("/feedback/submit", formData);
      // console.log(res);

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Ошибка отправки");
    }
  }
);

// Получение всех отзывов
export const fetchAllFeedback = createAsyncThunk(
  "feedback/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${url}/api/feedback/all`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Ошибка загрузки");
    }
  }
);
